import React, { useState } from 'react';
import { Box, Menu, MenuItem, ListItemText } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface CategoryTabLabelProps {
  label: string;
  routes: { id: string; name: string }[];
  selectedRouteId?: string;
  onSelectRoute: (routeId: string) => void;
}

/**
 * 分类 Tab 的标签内容：文字 + 下拉箭头，点箭头弹出该分类下的子路线菜单，
 * 选中后由外部切换到对应分类并联动流程图。
 */
const CategoryTabLabel: React.FC<CategoryTabLabelProps> = ({ label, routes, selectedRouteId, onSelectRoute }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
      {label}
      {routes.length > 0 && (
        <Box
          component="span"
          aria-label={`选择${label}下的路线`}
          onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
            e.stopPropagation();
            setAnchorEl(e.currentTarget);
          }}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            ml: 0.25,
            mr: -0.5,
            borderRadius: '50%',
            cursor: 'pointer',
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          <KeyboardArrowDownIcon fontSize="small" />
        </Box>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ sx: { maxHeight: 360 } }}
      >
        {routes.map((route) => (
          <MenuItem
            key={route.id}
            selected={route.id === selectedRouteId}
            onClick={() => {
              setAnchorEl(null);
              onSelectRoute(route.id);
            }}
          >
            <ListItemText primary={route.name} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default CategoryTabLabel;
